import React, { useState, useEffect, Fragment } from 'react';
import Msg from "~/components/messages";
import { Input, InputGroup, InputGroupText, InputGroupAddon, Spinner } from 'reactstrap';
import { Save } from 'react-feather';
import { Link, useHistory } from 'react-router-dom';
import Promotion from "~/services/promotions";
import ValidationGroup from "~/components/validation";

const Giveaway = () => {

  const [giveawayCode , setGiveawayCode ] = useState("");
  const [isLoading , setLoading] = useState(false);
  const validation = ValidationGroup("Giveaway");
  const history = useHistory();

  const  hasErrors = () => {

    const errorList = {
      ...validation("code", giveawayCode)
    };

    if(Boolean(Object.keys(errorList).length)) {
      Msg.emptyCode(errorList.code);
      return;
    }
    else{
      setLoading(true);
      Promotion.find({code: giveawayCode})
      .then(() => history.push(`/tgbonus/${giveawayCode}`))
      .catch(err => {
        Msg.emptyCode(err.data ? err.data.error : err.generalError);
        setLoading(false);
      });
    }
   };

  return (
    <Fragment>

      <h5 className="m-t-30 m-b-20 text-center"> Bonus Code </h5>

      <InputGroup className="input-group-round ref-input m-b-15">
        <InputGroupAddon addonType="prepend"><InputGroupText  className="span-left"><strong>Code</strong></InputGroupText></InputGroupAddon>
        <Fragment>
          <Input type="text"
            value={giveawayCode}
            onChange={(e)=> setGiveawayCode(e.target.value)}
            placeholder="Enter Bonus Code"
          />

          <InputGroupAddon addonType="append">
            <InputGroupText  className="divider span-right">
              <div className="text-dark" onClick={hasErrors}> 
                { isLoading ? 
                  <Spinner></Spinner> :
                  <Save className="text-muted"/>
                }  
              </div>
            </InputGroupText>
          </InputGroupAddon>
        </Fragment>
      </InputGroup>

    </Fragment>
  );
}

export default Giveaway